import {useUserDevice} from "@pg-mono/user-device";

export const useResponsiveOpenLink = (link: string) => {
    const {isMobile} = useUserDevice();

    return (nextLinkOrEvent?: unknown) => {
        const nextLink = typeof nextLinkOrEvent === "string" ? nextLinkOrEvent : link;

        if (isMobile) {
            window.location.href = nextLink;
            return;
        }

        window.open(nextLink, "_blank");
    };
};
import {useUserDevice} from "@pg-mono/user-device";

export const useResponsiveOpenLink = (link: string) => {
    const {isMobile} = useUserDevice();

    return (nextLinkOrEvent?: unknown) => {
        const nextLink = typeof nextLinkOrEvent === "string" ? nextLinkOrEvent : link;

        if (isMobile) {
            window.location.href = nextLink;
            return;
        }

        window.open(nextLink, "_blank");
    };
};
